import { useEffect, useState } from 'react'

export const useShowDefaultProfileIcon = (pictureUrl?: string) => {
  const [showProfile, setShowProfile] = useState(false)
  const [imageFetched, setImageFetched] = useState(false)

  useEffect(() => {
    const fetchImage = () => {
      if (!pictureUrl) return

      const testImg = new Image()

      testImg.onload = () => {
        setImageFetched(true)
      }

      testImg.onerror = () => {
        setShowProfile(true)
        setImageFetched(true)
      }

      testImg.src = pictureUrl
    }

    if (!imageFetched) fetchImage()
  }, [imageFetched, setImageFetched, setShowProfile, pictureUrl])

  return {
    showProfile,
  }
}
